/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { API_GATEWAY_ROOT } from "@danishagro/shared/src/constants/urlRoot.constants";

type BodyType = {
    customerNumber?: string;
};

export const useFormValidation = () => {
    const { getDictionaryString } = useTranslations();

    const [validationErrorMessages, setValidationErrorMessages] = useState<
        { key: string; value: string }[]
    >([]);

    // Input change
    const onInputChange = (key: string) => {
        const result = validationErrorMessages.filter((x) => x.key !== key);
        setValidationErrorMessages(result);
    };

    // Validate
    const validate = async (body: BodyType) => {
        const tmpErrorMessages: { key: string; value: string }[] = [];

        //Customer number Mandatory
        if (!body.customerNumber) {
            tmpErrorMessages.push({
                key: "customerNumber",
                value: getDictionaryString("SupplierService.ValidationRequired"),
            });
        }

        // Call the API to validate customer number
        const isValidCustomer = await isValidCustomerApi(String(body.customerNumber));

        if (!isValidCustomer) {
            tmpErrorMessages.push({
                key: "customerNumber",
                value: getDictionaryString("SupplierService.ValidationInvalid"),
            });
        }

        setValidationErrorMessages(tmpErrorMessages);

        if (tmpErrorMessages.length === 0 && isValidCustomer) {
            // Reset errors when validation is successful
            resetErrors("customerNumber");
        }

        return [tmpErrorMessages.length === 0, isValidCustomer];
    };

    //Validate the written customer number and validate against the api
    const isValidCustomerApi = async (customerNumber: string) => {
        if (!customerNumber) {
            return false;
        }

        const validateUrl = `${API_GATEWAY_ROOT}/user/isvalidcustomernumber?customerNumber=${customerNumber}`;

        try {
            const response = await fetch(validateUrl, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                console.error(`Error: ${response.status} - ${response.statusText}`);
                return false;
            }

            const data = await response.json();
            return data;
        } catch (error) {
            return false;
        }
    };

    // Get Error
    const getError = (name: string) => {
        return validationErrorMessages?.find((x) => x.key === name);
    };

    //Reset error
    const resetErrors = (name?: string) => {
        let result = validationErrorMessages;

        if (typeof name !== "undefined") {
            result = validationErrorMessages?.filter((x) => x.key !== name);
        } else {
            result = [];
        }

        setValidationErrorMessages(result);
    };

    return {
        validationErrorMessages,
        validate,
        getError,
        resetErrors,
        onInputChange,
    };
};
